var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
  pluginRegistry.registerDeploymentAction("Octopus.TentaclePackage", function(busy, octopusRepository) {
    return {
      executionLocation: actionExecutionLocations.alwaysOnTarget,
      canChooseRoles: true,
      canHaveChildren: function() { return true; },
      canBeChild: true,
      hasPackages: function(action) { return true; },
      features: {
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
          "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles",
          "Octopus.Features.IisHome", "Octopus.Features.IISWebSite", "Octopus.Features.RedGateDatabase", "Octopus.Features.WindowsService"],
        initial: ["Octopus.Features.ConfigurationTransforms","Octopus.Features.ConfigurationVariables"]
      },

            summaryTemplateUrl: "areas/projects/actions/Octopus.TentaclePackage_summary.html",

            editTemplateUrl: "areas/projects/actions/Octopus.TentaclePackage_edit.html",
            editLink: function ($scope, element) {
                var isLoading = $scope.isLoading = busy.create();

                if (!$scope.action.Properties["Octopus.Action.Package.FeedId"] && $scope.feeds.length > 0) {

                    // We're adding a new action
                    $scope.action.Properties["Octopus.Action.EnabledFeatures"] = "Octopus.Features.ConfigurationTransforms,Octopus.Features.ConfigurationVariables";
                    pluginRegistry.getFeature("Octopus.Features.ConfigurationTransforms").enable($scope.action);
                    pluginRegistry.getFeature("Octopus.Features.ConfigurationVariables").enable($scope.action);
                }

                if (!$scope.action.Properties["Octopus.Action.Package.DownloadOnTentacle"]) {
                    $scope.action.Properties["Octopus.Action.Package.DownloadOnTentacle"] = "False";
                }
            },
            summaryLink: function ($scope, element) {
                var variableExpressionRegex = /^#{(.*?)}$/;
                var matches = $scope.properties["Octopus.Action.Package.PackageId"].match(variableExpressionRegex);
                $scope.packageId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.PackageId"];

                matches = $scope.properties["Octopus.Action.Package.FeedId"].match(variableExpressionRegex);
                $scope.feedId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.FeedId"];
                return octopusRepository.Feeds.get($scope.feedId).then(function (feed) {
                    $scope.feedName = feed.Name;
                });
            }
        };
    });
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.TentaclePackage.js
// module id = 4432423401655230
// module chunks = 1